import * as yup from "yup";

export const guestFormValidation = yup.object({
  name: yup
    .string()
    .min(3, "*Full name must be at least 3 characters long")
    .required("*Full name is required"),
  email: yup
    .string()
    .email("*Please enter a valid email address")
    .required("*Email is required"),
  mobile: yup
    .string()
    .matches(/^[0-9]{10}$/, "*Contact number must be exactly 10 digits")
    .required("*Contact number is required"),
});

export type GuestFormValidationType = yup.InferType<typeof guestFormValidation>;
